const OPERATION_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Receipt links issued before the operation id carry a ledger transaction id instead.
export function isOperationId(id: string | null | undefined): boolean {
  return OPERATION_ID_PATTERN.test(id?.trim() ?? "");
}
